import styled from 'styled-components'

export const WidgetContainer = styled.div`
  background: ${props => props.theme.widgetColor};
  overflow: hidden;
  width: 100%;
  padding: 48px;
  border-radius: 28px;
  border: 1px solid ${props => props.theme.primaryBorderColor};
`